import Alpine from "alpinejs";
let $up = document.querySelector('.footer-top-up');

if ($up) {
    $up.addEventListener('click', (event) => {
        document.getElementById('header').scrollIntoView({
            behavior: 'smooth'
        });
    });
}


Alpine.data('bottomnav', function (initialOpenState = false){
    return {
        open: initialOpenState,

        toggle() {    
            this.open = ! this.open
        },
    }
});

